import React, { useState } from 'react';
// material
import { withStyles, Theme } from '@material-ui/core/styles';
import moment from 'moment';
import { SentTextIcon, NoteBookIcon, PhoneIcon } from "../../../assets"
import { Hidden } from '@material-ui/core';
import EmptyScreen from "../EmptyPage"
import ContactActions from "./contactActions"
import type { ContactInfo, History } from "../types"
import { CampaignContact } from '../../../entities/site';
import { User } from '../../../entities/user';

import { Actions } from '../NextAction';

const styles: any = (theme: Theme) => ({
  container: {
    padding: "30px 0 30px 30px",
    height: "100%",
    [theme.breakpoints.down('sm')]: {
      padding: "30px 0",
      height: "auto"
    }
  },
  contentContainer: {
    marginTop: "30px",
    height: "calc(100% - 80px)",
    [theme.breakpoints.down('md')]: {
      height: "auto"
    }

  },
  label: {
    fontSize: '20px',
    color: '#627995',
    fontFamily: "Roboto",
    marginTop: 20
  },
  itemContainer: {
    padding: '20px',
    border: " 1px solid #E0E0E0",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: 10,
    marginTop: 20,
    display: 'flex',
    alignItems: 'center',
  },
  info: {
    color: '#000000',
    fontFamily: "Roboto",
  },
  subText: {
    fontSize: '14px',
    color: '#627995',
    fontFamily: "Roboto",
    marginTop: 9
  },
  icon: {
    height: "40px",
    width: "40px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 20,
    "& path": {
      fill: "#00ABCA"
    },
    "& rect": {
      fill: "#00ABCA"
    }
  },
  seperator: {
    borderTop: "1px solid #E0E0E0",
    marginTop: "40px",
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "Roboto",
    paddingTop: "20px"
  },
})

interface HistoryProps {
  history: History[];
  classes: any;
  contact: CampaignContact;
  onAction(action: Actions, actionText: string): void;
}

const HistoryDetails: React.FC<HistoryProps> = (props) => {

  const { classes, history, contact, onAction } = props

  const groupByDate = () => {
    const groupBy = history.reduce((group, item: History) => {
      const date = moment(item.date).format("MM/DD/YYYY");
      group[date] = group[date] ?? [];
      group[date].push(item);
      return group;
    }, {});
    return groupBy
  }

  const historyData = React.useMemo(groupByDate, [history])

  const renderHistoryItem = (historyItem: History, index: number) => (
    <div key={index} className={classes.itemContainer}>
      <div className={classes.icon}>
        {historyItem.type === "call" ? <PhoneIcon /> : historyItem.type === "text" ? <SentTextIcon /> : <NoteBookIcon />}
      </div>
      <div>
        <div className={classes.info}>{historyItem.type === "call" ? `Call made at ${moment(historyItem.date).format("hh:mma")}` : historyItem.data}</div>
        <div className={classes.subText}>From:&nbsp;{historyItem.from} | {moment(historyItem.date).format("MMM DD, YYYY")}</div>
      </div>
    </div>
  )

  const renderHistory = (historyInfo: any, index: number) => (
    <div key={index}>
      <div className={classes.label}>{historyInfo[0]}</div>
      {historyInfo[1].map(renderHistoryItem)}
    </div>
  )

  return (
    <div className={classes.container}>
      <Hidden smDown>
        <ContactActions contact={contact} onAction={onAction} />
      </Hidden>
      <Hidden only={['md', 'lg', 'xl']}>
        <div className={classes.seperator}>
          History

        </div>
      </Hidden>
      <div className={classes.contentContainer}>
        {history.length ? Object.entries(historyData).map(renderHistory) : <EmptyScreen message="No history to show yet" />}
      </div>
    </div>
  )
}

export default withStyles(styles)(HistoryDetails);



// WEBPACK FOOTER //
// ./src/pages/next-action/contactInfo/history.tsx